import useJsScript from "../hooks/use-js-script";

export default function GradientCanvas() {
  useJsScript("/js/gradient-effect.js");

  return (
    <canvas
      id="gradient-canvas"
      className="absolute inset-0 w-full h-full -z-10"
      style={
        {
          "--gradient-color-1": "#fff",
          "--gradient-color-2": "#a6c6eb7a",
          "--gradient-color-3": "#82bc81",
          "--gradient-color-4": "#5cb6a2 ",
        } as React.CSSProperties
      }
    />
  );
}
